// extracted by mini-css-extract-plugin
export default {"category":"Categories_category__EGx-W"};